import { OverAllStatis } from './OverAllStatis'
import { withOverAllStatis } from './withOverAllStatis'

const Connected = withOverAllStatis(OverAllStatis)

export { Connected as OverAllStatis }
